import React from 'react';
import { SplitResult } from '../../types';
import { cn } from '../../lib/utils';

interface SplitBreakdownProps {
  splits: SplitResult[];
  className?: string;
}

export const SplitBreakdown: React.FC<SplitBreakdownProps> = ({ splits, className }) => {
  return (
    <div className={cn("space-y-4", className)}>
      <div className="flex h-3 w-full rounded-full overflow-hidden bg-gray-100 p-0.5 shadow-inner dark:bg-slate-800">
        {splits.map((split, i) => (
          <div
            key={split.nodeId}
            className="h-full transition-all duration-500 first:rounded-l-full last:rounded-r-full"
            style={{ 
              width: `${split.percentage}%`, 
              backgroundColor: split.nodeColor,
              opacity: 0.9 - (i * 0.1)
            }}
            title={`${split.nodeName}: ${split.percentage}%`}
          />
        ))}
      </div>
      
      <div className="grid gap-2">
        {splits.map((split, i) => (
          <div key={split.nodeId} className="flex items-center justify-between p-2.5 rounded-xl border border-gray-100 hover:bg-gray-50 transition-colors dark:bg-slate-950">
            <div className="flex items-center gap-3">
              <div 
                className="w-2 h-2 rounded-full" 
                style={{ backgroundColor: split.nodeColor }} 
              />
              <div>
                <p className="text-xs font-bold text-gray-900 dark:text-white">{split.nodeName}</p>
                <p className="text-[10px] text-gray-400 font-mono uppercase tracking-widest leading-none mt-0.5">
                  {i === 0 ? 'Recipient' : i === splits.length - 1 ? 'Platform Fee' : 'Upstream Tier'}
                </p>
              </div>
            </div>
            <div className="text-right">
              <p className="text-sm font-black text-gray-900 dark:text-white">${split.amount.toFixed(2)}</p>
              <p className="text-[10px] font-bold text-gray-400 font-mono">{split.percentage}%</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
